import React, { useContext } from 'react';
import './PageTitle.scss';
import { LanguageContext } from '../../context/LanguageContext';

const PageTitle = () => {
    const { t } = useContext(LanguageContext);

    return (
        <div className='page-title'>
            <div className="container">
                <h1>{t('blogs.title')}</h1>
                <p>{t('blogs.description')}</p>
            </div>
        </div> 
    );
};

export default PageTitle;